import React from 'react';
import image1 from '../../../../../images/modules/module-1/11.png';
import image2 from '../../../../../images/modules/module-1/12.png';
import image3 from '../../../../../images/modules/module-1/13.png';
import image4 from '../../../../../images/modules/module-1/14.png';
import image5 from '../../../../../images/modules/module-1/15.png';
import image6 from '../../../../../images/modules/module-1/16.png';
import { Ad } from '../Ad';
import './index.scss';

export const Awa300x600Content = ({ src }) => {
    return (
        <div className='revue-awa-300x600'>
            <div className='revue-awa-300x600-widget'>
                <iframe title='300x600' src={src} width={300} height={600} scrolling='no' />
            </div>
            <div className='revue-awa-300x600-content'>
                <div className='revue-awa-300x600-content__item'>
                    <Ad
                        src={image1}
                        category='Shopping'
                        title='New Balance Sneakers 101: A Guide to Shopping the Iconic Sneakers from the 990 to 574'
                        type='inverted'
                        contentHeightSmall
                    />
                </div>
                <div className='revue-awa-300x600-content__item'>
                    <Ad
                        src={image2}
                        category='Music'
                        title='30 Dreamy Vintage Snapshots of a Young Mariah Carey'
                        type='inverted'
                        contentHeightSmall
                    />
                </div>
                <div className='revue-awa-300x600-content__item'>
                    <Ad
                        src={image3}
                        category='Fashion'
                        title='How This Small Town Designer Became Suki Waterhouse`s Secret Style Weapon'
                        type='inverted'
                        contentHeightSmall
                    />
                </div>
                <div className='revue-awa-300x600-content__item'>
                    <Ad
                        src={image4}
                        category='Shopping'
                        title='The Best Bridesmaid Dresses Your Wedding Party Will Actually Love'
                        type='inverted'
                        contentHeightSmall
                    />
                </div>
                <div className='revue-awa-300x600-content__item'>
                    <Ad
                        src={image5}
                        category='Shopping'
                        title='La Vie en Rose! 8 Refreshing Ways to Style Pink This Spring'
                        type='inverted'
                        contentHeightSmall
                    />
                </div>
                <div className='revue-awa-300x600-content__item'>
                    <Ad
                        src={image6}
                        category='Music'
                        title='5 Key Takeaways From Chappell Roan’s Guest Appearance on Call Her Daddy'
                        type='inverted'
                        contentHeightSmall
                    />
                </div>
            </div>
        </div>
    );
};
